export default __webpack_public_path__ + "static/media/figuremap56.5a65171d.png";